module.exports = __webpack_public_path__ + "static/media/lagefi.fa61d349.png";